import {
  Box,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Queue } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import { QueueSelect } from 'fable/queueSelect';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { notificationActions } from '../../../notifications/actions/notification';
import { transferToQueueActions } from '../actions/transferToQueueModal';
import { TransferToQueueModalState } from '../reducers/transferToQueueModal';

const mapStateToProps = (state: RootReducerStateT) => {
  return state.transferToQueue;
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    transferToQueueModalRequest: bindActionToPromise(
      dispatch,
      transferToQueueActions.transferToQueueModalRequest,
    ),
    modalOpen: (payload: TransferToQueueModalState) =>
      dispatch(transferToQueueActions.transferToQueueModalOpen(payload)),
    modalClose: () =>
      dispatch(transferToQueueActions.transferToQueueModalClose()),
    notificationAdd: (payload) =>
      dispatch(notificationActions.notificationAdd(payload)),
    transferToQueueModalRequestStop: (csid: number | null) =>
      dispatch(
        transferToQueueActions.transferToQueueModalRequestStop({ csid }),
      ),
  };
};

type StatePropsT = ReturnType<typeof mapStateToProps>;
type DispatchPropsT = ReturnType<typeof mapDispatchToProps>;

type PropsT = StatePropsT & DispatchPropsT;

type StateT = {
  selectedQueue: Queue | null;
};

class TransferToQueueModal extends Component<PropsT, StateT> {
  constructor(props: PropsT) {
    super(props);

    this.state = {
      selectedQueue: null,
    };
  }

  componentDidUpdate(prevProps: PropsT) {
    if (
      this.props.ui.isModalShown === false &&
      prevProps.ui.isModalShown === true
    ) {
      this.setState({
        selectedQueue: null,
      });
    }
  }

  @boundMethod
  onRequest() {
    const { selectedQueue: requestToQueue } = this.state;

    if (!requestToQueue) {
      return;
    }

    const {
      csid,
      transferToQueueModalRequestStop,
      modalClose,
      notificationAdd,
    } = this.props;

    this.props
      .transferToQueueModalRequest({
        requestToQueue,
        csid,
      })
      .then(() => {
        if (csid) {
          ampli.conversationTransferred({
            conversationId: csid,
            option: 'queue',
          });
        }

        transferToQueueModalRequestStop(csid);
        modalClose();
      })
      .catch((exception) => {
        console.warn(exception);
        transferToQueueModalRequestStop(csid);
        modalClose();
        const options = {
          title: 'Could not transfer the conversation',
          text: `An issue occurred while trying transfer conversation ${csid}.`,
          className: 'danger',
          icon: 'i-exclamation',
        };
        notificationAdd(options);
      });
  }

  @boundMethod
  onSelectQueue(queue: Queue) {
    this.setState({ selectedQueue: queue });
  }

  render() {
    const { ui, csid, modalClose } = this.props;
    const { isModalShown } = ui;
    const { selectedQueue } = this.state;

    return (
      <Modal isOpen={isModalShown} onClose={modalClose}>
        <ModalHead
          title={`Transfer ${csid} to a different queue`}
          onClose={modalClose}
        ></ModalHead>
        <ModalBody>
          <Box width="540px">
            <QueueSelect
              selectedQueue={selectedQueue}
              onSelect={this.onSelectQueue}
            />
          </Box>
        </ModalBody>

        <ModalFoot
          cancelOnClick={modalClose}
          confirmName="Transfer"
          confirmProps={{ disabled: !selectedQueue }}
          confirmOnClick={this.onRequest}
        ></ModalFoot>
      </Modal>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransferToQueueModal);
